import React, { useState } from 'react';
import useAddAllToCart from '../../../hooks/use-add-all-to-cart';
import { findFormat } from '../../../lib/bookstore-util';
import { getAttributeValue } from '../../../lib/attribute';
import Button from '../../button';
import useCustomer from '../../../hooks/use-customer';

interface Props {
  cart: any;
  product: any;
  overrideFormat?: string;
}

const BookstoreButton: React.FC<Props> = ({
  cart,
  product,
  overrideFormat,
}) => {
  const [isAdding, setAdding] = useState(false);

  const customer = useCustomer();

  const cartItem = cart.items.find((i) => i.product.sku === product.sku);
  const isAtMaxQuantity =
    cartItem &&
    cartItem.maxQuantity > 0 &&
    cartItem.quantity >= cartItem.maxQuantity;

  const format = overrideFormat ?? findFormat(product);

  const addToCart = useAddAllToCart({
    onCompleted: () => {
      setAdding(false);
    },
  });

  const onClick = () => {
    setAdding(true);

    if (cartItem) {
      if (
        cartItem.maxQuantity > 0 &&
        cartItem.quantity >= cartItem.maxQuantity
      ) {
        setAdding(false);
        return;
      }
    }

    addToCart([
      {
        productId: product.id,
        quantity: 1,
        format: format,
      },
    ]);
  };

  const onDownload = () => {
    window.location.href = getAttributeValue(product.attributes, 'url') ?? '/';
  };

  const onWallet = (id) => {
    window.location.href = `/owners/wallet/${encodeURIComponent(id)}`;
  };

  // Wallet
  if (
    getAttributeValue(product.attributes, 'itemsubtype') ===
      'Complete Wallets' &&
    getAttributeValue(product.attributes, 'chassisbreak').length > 0
  ) {
    if (
      product.inventoryCount > 0 ||
      customer?.customer!.permissions.some(
        (p) => p.toLowerCase() === 'canbackorder'
      )
    ) {
      return (
        <Button text="Build Wallet" onClick={() => onWallet(product.sku)} />
      );
    } else {
      return <Button text="Out of Stock" disabled={true} onClick={() => {}} />;
    }
  }

  if (!product.physical || format === 'pdf' || product.inventoryCount > 0) {
    // TODO: Improve check using the itemTypeToLibraryGroup function compared to user permissions
    if (
      format === 'pdf' &&
      customer &&
      !customer.customer!.guest &&
      getAttributeValue(customer?.customer?.attributes ?? [], 'vidaId').length
    ) {
      return <Button text="Download PDF" onClick={() => onDownload()} />;
    } else {
      return (
        <React.Fragment>
          <Button
            text="Add to Cart"
            disabled={
              !product.cartAddable.addable ||
              isAdding ||
              (cartItem && isAtMaxQuantity)
            }
            margin={false}
            onClick={() => onClick()}
          />
          {cartItem && (
            <p className="addedToCart">{`${cartItem.quantity} in cart.`}</p>
          )}
          <style jsx>
            {`
              .addedToCart {
                color: green;
                font-weight: bold;
              }
            `}
          </style>
        </React.Fragment>
      );
    }
  } else {
    if (
      customer?.customer!.permissions.some(
        (p) => p.toLowerCase() === 'canbackorder'
      )
    ) {
      return (
        <Button
          text="Backorder"
          disabled={!product.cartAddable.addable}
          onClick={() => onClick()}
        />
      );
    } else {
      return <Button text="Out of Stock" disabled={true} onClick={() => {}} />;
    }
  }
};

export default BookstoreButton;
